import { getApolloClient } from '@core/apollo/client';
import type { LoaderFunctionArgs } from 'react-router-dom';

import type { AuditSessionLoaderData } from '../domain/AuditSessionLoaderData';
import { GET_AUDIT_SESSION } from '../graphql/queries/getAuditSession';

/**
 * Loader for audit session route
 * Fetches audit session data before the route renders
 * Uses Apollo Client singleton to access the client outside React context
 */
export async function auditSessionLoader({ params }: LoaderFunctionArgs): Promise<AuditSessionLoaderData> {
  const client = getApolloClient();
  const communityId = params.communityId as string;
  const sessionId = params.sessionId as string;

  const { data } = await client.query({
    query: GET_AUDIT_SESSION,
    variables: { communityId, sessionId },
    fetchPolicy: 'cache-first',
  });

  return {
    auditSession: data.community.auditSession,
  };
}
